// import "core-js/es/set";
// import "core-js/es/map";
import 'intl';
import 'intl/locale-data/jsonp/en-AU';
import './css/h5bp/normalize.css';
import './css/font-awesome.css';
import './css/main.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css'; // Needed for react-grid-layout
import 'tippy.js/dist/tippy.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from "react-router-dom";
import configureStore from './reducers/configureStore';
import App from './routes';
import { unregister } from './registerServiceWorker';
import { MuiThemeProvider, createTheme, alpha } from '@material-ui/core/styles';
import { IntlProvider } from 'react-intl';
import CssBaseline from '@material-ui/core/CssBaseline';
import {
	bootstrap
} from './reducers/bootstrap';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import './sentry';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import LogRocket from 'logrocket';
import history from './history';
import some from 'lodash/some';
import { setAutoFreeze } from 'immer';

if (window.Contrack && window.Contrack.SentryDSN) {
	Sentry.init({
		environment: window.Contrack.Environment,
		dsn: window.Contrack.SentryDSN,
		release: "contrack@" + process.env.npm_package_version,
		integrations: [
			new Integrations.BrowserTracing({
				routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
			})
		],

		// We recommend adjusting this value in production, or using tracesSampler
		// for finer control
		tracesSampleRate: 1.0,

		tracesSampler: samplingContext => {
			const eventsToAlwaysTrack = [
				'/api/dashboard/contract-summary',
				'/api/lots',
				'/api/progress-claim'
			];

			const eventsToSometimesTrack = [
				'/',
				'/lots',
				'/progress-claims'
			];
		
		
			if (some(eventsToAlwaysTrack, e => e === samplingContext.transactionContext.name)) {
			  return 1;
			} else if (some(eventsToSometimesTrack, e => e === samplingContext.transactionContext.name)) {
			  return 0.1;
			} else {
			  return 0.01;
			}
		}
	});
}

if (window.Contrack && window.Contrack.LogRocketAppId) LogRocket.init(window.Contrack.LogRocketAppId);

const theme = createTheme ({
	palette: {
		primary: {
			main: '#0E76BC',
			contrastText: '#fff'
		},
		secondary: {
			main: 'rgb(141, 198, 63)',
			contrastText: '#fff'
		},
		wizard: {
			main: '#009efb',
			contrastText: '#fff',
			light: alpha('#009efb', 0.5),
			dark: alpha('#009efb', 0.9)
		}
	},
	overrides: {
		MuiFilledInput: {
			root: {
				'@media print': {
					background: 'none'
				}
			}
		}
	},
	props: {
		MuiButton: {
			color: 'default'	
		},
		MuiCheckbox: {
			color: 'primary'
		}
	}
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState || {};
export const store = configureStore(initialState);
store.dispatch(bootstrap());
store.dispatch({ type: 'BOOTSTRAP_DATA' });

const rootElement = document.getElementById("root");

const ProfiledApp = window.Contrack && window.Contrack.SentryDSN ? Sentry.withProfiler(App) : App;

setAutoFreeze(false);

ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<React.Fragment>
				<MuiThemeProvider theme={theme}>
					<CssBaseline />
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<IntlProvider locale='en-au'>
							<ProfiledApp />
						</IntlProvider>
					</MuiPickersUtilsProvider>
				</MuiThemeProvider>
			</React.Fragment>
		</Router>
	</Provider>,
	rootElement
);

// registerServiceWorker();

unregister();